import { render, staticRenderFns } from "./BlockTopNavigation.vue?vue&type=template&id=1589a9de&"
import script from "./BlockTopNavigation.vue?vue&type=script&lang=js&"
export * from "./BlockTopNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports